// This is api.js

  // ^^^^^^^ WORKING API FUNCTION  ^^^^^  

   export const createStripePaymentLink = async (idToken) => {
       const res = await fetch('https://1azyop0jo8.execute-api.eu-west-2.amazonaws.com/dev/create-payment-link', {
         method: 'POST',
         headers: {
           Authorization: `Bearer ${idToken}`,
         },
       });
       if (!res.ok) throw new Error('Failed to create Stripe payment link');
       const { url } = await res.json();
       return url;
     };

  // Mock data for ratios
export const STOCK_SEARCH_LIST = {
//   "AAPL": {},
//   "GOOGL": {},
//   "TSLA": {}, 
//   "AMZN": {}, 
//  "MSFT": {}, 
//  "NVDA": {}

"AAPL": {},
"GOOGL": {},
"TSLA": {}, 
"AMZN": {}, 
"MSFT": {}, 
"NVDA": {},
"META": {},
"NFLX": {},
"CRM": {},
"ADBE": {},


  
};

  
export const fetchPublicFmpMetrics = async (symbol, type = 'ratios') => {
  // const url = `https://d1imbma6yo5wmc.cloudfront.net/public-fmp-metrics?symbol=${symbol}&type=${type}`;
   // >>>>>>>>>>>>>>>>>>>>>> Code to add >>>>>>>>>>>>
   const url = `/public-fmp-metrics?symbol=${symbol}&type=${type}`;
   // <<<<<<<<<<<<<<<<<<<<<<< Code to add <<<<<<<<<<<
 
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error(`Failed to fetch ${type} data for ${symbol}`);
  }

  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (err) {
    console.error(`Invalid JSON for ${symbol}:`, text.slice(0, 200));
    throw new Error(`Response for ${symbol} is not valid JSON`);
  }
};

  //  export const fetchHistoricalData = (symbol) =>
  //    fetchPublicFmpMetrics(symbol, 'historical').then((data) => data.historical || []);

  export const fetchHistoricalData = (symbol) =>
  fetchPublicFmpMetrics(symbol, 'historical').then((data) => {
    // New FMP stable endpoint returns a plain array:
    // [ { symbol, date, open, high, low, close, volume, vwap, changePercent }, ... ]
    if (Array.isArray(data)) {
      return data;
    }

    // Backward-compatibility in case the backend ever wraps it:
    if (data && Array.isArray(data.historical)) {
      return data.historical;
    }

    console.error('Unexpected historical data shape:', data);
    return [];
  });
  
   export const fetchMetrics = (symbol) =>
     fetchPublicFmpMetrics(symbol, 'ratios').then((data) => data?.[0] || null);


     